
import state from './moduleUserTypeManagementState'
import mutations from './moduleUserTypeManagementMutations'
import actions from './moduleUserTypeManagementActions'
import getters from './moduleUserTypeManagementGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

